
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import QRCode from 'qrcodejs2';
export default {
components: {
CheckIcon,
QRCode
},
data() {
return {
isAgree: true,
dialogVisible: false,
wxqrcodeReset: true,
aliqrcodeReset: true,
payWay: 10,
pageLoad: false,
goodsOrder: {},
serverTime: '' 
};
},
methods: {
open(goodsOrder) {
this.goodsOrder = {
duration: '',
...goodsOrder
};
this.payOrder(10);
this.payOrder(11);

this.dialogVisible = true;

let that = this;
that.getServerTime(function() {
that.countDurationRemark();
clearInterval(window.payCountInterval);
window.payCountInterval = null;
let resultCount = 0;
window.payCountInterval = setInterval(() => {
resultCount++;
if (resultCount % 5 == 0 && !that.$store.state.APPPAGE.wsStatus) {
console.log('刷新订单详情，查询订单状态');
that.checkStatus();
}
that.countDurationRemark();
}, 1000);
});
},
countDurationRemark() {
this.serverTime++;
var endT = this.goodsOrder.createTime + 24 * 3600;
var startT = new Date().getTime() / 1000;


if (startT <= this.serverTime) {


endT = endT - (this.serverTime - startT);
} else {

endT = endT + (startT - this.serverTime);
}
var duration = this.$countDuration(startT, endT, 'timestamp', 'second');
if (duration == '0秒') {
clearInterval(window.payCountInterval);
window.payCountInterval = null;
this.$vux.toast.text('超时未支付，该订单已自动关闭！');
this.$emit('loadDetail');
this.dialogVisible = false;
} else {
this.goodsOrder.duration = duration;
}
},

getServerTime(callback) {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/getTime', {
params: {}
})
.then(function(res) {
if (res.status == 200) {
that.serverTime = res.body;
callback && callback();
}
});
},
loadStatus(callback) {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/orderDetails', {
params: {
goodsOrderId: that.goodsOrder.goodsOrderId
}
})
.then(function(response) {
if (response.status == 200) {
callback && callback(response.body.status);
}
});
},
checkStatus() {
let that = this;
that.loadStatus(status => {
if (status != 0) {
console.log('订单已支付');
that.dialogVisible = false;
that.$emit('loadDetail');
that.$vux.toast.text('订单支付成功！');
} else {
console.log('订单未支付');
}
});
},
onHide() {
clearInterval(window.payCountInterval);
window.payCountInterval = null;
this.payWay = 10;
this.wxqrcodeReset = this.aliqrcodeReset = false;
this.$nextTick(() => {
this.wxqrcodeReset = this.aliqrcodeReset = true;
});
},
payOrder(payWay) {
let that = this;
that.pageLoad = true;
var goodsOrderId = that.goodsOrder.goodsOrderId;
var redirect_url = sessionStorage.domainURL + '/LonBonStore/#/mallOrderDetail?token=' + sessionStorage.token + '&readyPayOrderId=' + goodsOrderId + '&redirect=true';
var payOrder = {
description: '订单支付',
payWay: payWay,
wapUrl: sessionStorage.domainURL,
wapName: '来邦移动商城',
returnUrl: redirect_url,
goodsOrderId: goodsOrderId,
prices: that.goodsOrder.orderTotalPrices
};
var data = {
payOrder: JSON.stringify(payOrder)
};
console.log(data);
that.$axios
.post('/api/v1.0/lonbonShop/pay', that.qs.stringify(data))
.then(function(response) {
if (response.status == 200) {
var qrcodeId = payWay == 10 ? 'wxqrcode' : 'aliqrcode';
that[qrcodeId + 'Reset'] = false;
that.$nextTick(() => {
that[qrcodeId + 'Reset'] = true;
that.$nextTick(() => {
new QRCode(qrcodeId, {
width: 180,
height: 180,
text: payWay == 10 ? response.body.weChatOrder.codeUrl : response.body.aliPayOrder.codeUrl
});
});
});
}
that.pageLoad = false;
})
.catch(function() {
that.pageLoad = false;
});
}
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/payDialog.vue